import { Action, createReducer, on } from "@ngrx/store";

import * as DictionaryActionTypes from "../../actions/dictionary/dictionary.actions";

import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";
import { DictionaryAsPropertiesDTO } from "src/app/models/languages-management/dictionaryAsPropertiesDTO";

export interface DictionaryState {
  isLoading: boolean;
  dictionaryList: DictionaryAsPropertiesDTO[];
  dictionaryExcelList: DictionaryAsPropertiesDTO[];
  totalRecords: number;
  propertiesList: PropertyDTO[];
  properties: PropertyDTO[];
  dictionaryTableConfig: ColumnSorterInfo[];
  dictionary: DictionaryAsPropertiesDTO;
  created: boolean;
  deleted: boolean;
  error: Error;
}

export const initialState: DictionaryState = {
  isLoading: false,
  dictionaryList: null,
  dictionaryExcelList: null,
  totalRecords: 0,
  propertiesList: null,
  properties: null,
  dictionaryTableConfig: null,
  dictionary: null,
  created: false,
  deleted: false,
  error: null,
};

const dictionaryReducer = createReducer(
  initialState,
  on(DictionaryActionTypes.resetDictionaryState, () => initialState),
  on(
    DictionaryActionTypes.getDictionaryList,
    (state, { options }) =>
      ({
        ...state,
        isLoading: true,
        options: options,
        error: null,
      } as DictionaryState)
  ),
  on(
    DictionaryActionTypes.loadDictionaryList,
    (state, { response }) =>
      ({
        ...state,
        isLoading: false,
        dictionaryList: (response as any)?.result?.items
          ? (response as any)?.result?.items
          : undefined,
        totalRecords: (response as any)?.result?.size
          ? (response as any)?.result?.size
          : 0,
        error: null,
      } as DictionaryState)
  ),
  on(
    DictionaryActionTypes.getDictionaryExcelList,
    (state, { options }) =>
      ({
        ...state,
        isLoading: true,
        options: options,
        error: null,
      } as DictionaryState)
  ),
  on(
    DictionaryActionTypes.loadDictionaryExcelList,
    (state, { response }) =>
      ({
        ...state,
        dictionaryExcelList: (response as any)?.result?.items
          ? (response as any)?.result?.items
          : undefined,
        isLoading: false,
        error: null,
      } as DictionaryState)
  ),
  on(
    DictionaryActionTypes.loadPropertiesForListByUsage,
    (state, { response }) => {
      return {
        ...state,
        propertiesList: (response as any).result.items || [],
        error: null,
      };
    }
  ),
  on(DictionaryActionTypes.getDictionaryTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(DictionaryActionTypes.loadDictionaryTableConfig, (state, { response }) => {
    return {
      ...state,
      dictionaryTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(DictionaryActionTypes.saveDictionaryTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),

  on(
    DictionaryActionTypes.getDictionary,
    (state) =>
      ({
        ...state,
        error: null,
        isLoading: true,
        created: false,
        deleted: false,
      } as DictionaryState)
  ),
  on(DictionaryActionTypes.loadDictionary, (state, { dictionary }) => {
    return {
      ...state,
      dictionary: (dictionary as any).result,
      isLoading: false,
      error: null,
    };
  }),
  on(DictionaryActionTypes.loadPropertiesByUsage, (state, { response }) => {
    return {
      ...state,
      properties: (response as any)?.result?.items || [],
      error: null,
    };
  }),
  on(
    DictionaryActionTypes.createDictionary,
    DictionaryActionTypes.updateDictionary,
    DictionaryActionTypes.deleteDictionary,
    (state) => {
      return {
        ...state,
        isLoading: true,
      };
    }
  ),
  on(DictionaryActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(DictionaryActionTypes.deletedDictionarySuccessfully, (state) => {
    return {
      ...state,
      deleted: true,
    };
  }),
  on(DictionaryActionTypes.setLoadingDictionaryStartState, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(DictionaryActionTypes.setLoadingDictionaryEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: DictionaryState | undefined, action: Action) {
  return dictionaryReducer(state, action);
}
